import {
  Component,
  ElementRef,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { VehicleVersionReportService } from "src/app/services/vehicle-version-report.service";
import { VehicleDTO } from "src/app/model/VehicleDTO";
import { Table } from "primeng/table";
import * as _ from "lodash";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { VehicleVersionMenuItem } from "src/app/model/VehicleVersionMenuItem";
import { ReportConstants } from "../ReportConstants";

@Component({
    selector: "app-vehicle-version-report",
    templateUrl: "./vehicle-version-report.component.html",
    styleUrls: ["./vehicle-version-report.component.scss"],
    standalone: false
})
export class VehicleVersionReportComponent {
  vehicles: VehicleDTO[];
  isLoading: boolean;
  pageSize: number = 10; //tracks how many to query at a time
  pageNum: number = 0; //tracks what to query from
  numberOfRecords: number;
  isSubLoading = false;
  vehicleIdList: number[];
  brandList: String[];
  oemList: String[];
  nameplateList: String[];

  selectedVehicleIds: number[];
  selectedBrands: String[];
  selectedOems: String[];
  selectedNameplates: String[];

  constants = new ReportConstants();

  formGroup = new FormGroup({
    vehicleControl: new FormControl([], Validators.required),
    brandControl: new FormControl([], Validators.required),
    oemControl: new FormControl([], Validators.required),
    nameplateControl: new FormControl([], Validators.required),
    selectAllReportFilters: new FormControl(null),
  });

  @ViewChild("dt1") table!: Table;
  @ViewChildren("rows") rows: QueryList<ElementRef<HTMLTableRowElement>>;
  constructor(
    private vehicleVersionReportService: VehicleVersionReportService,
    private _renderer2: Renderer2
  ) {}

  ngOnInit(): void {
    this.getMenuItems();
    this.subscribeToFormControls();
    this.getNumberOfRecords(
      this.selectedOems,
      this.selectedBrands,
      this.selectedVehicleIds,
      this.selectedNameplates
    );
  }

  subscribeToFormControls() {
    this.formGroup.controls["vehicleControl"].valueChanges.subscribe(
      (value) => {
        this.onChangeVehicleId(value);
      }
    );
    this.formGroup.controls["brandControl"].valueChanges.subscribe((value) => {
      this.onChangeBrand(value);
    });
    this.formGroup.controls["oemControl"].valueChanges.subscribe((value) => {
      this.onChangeOem(value);
    });
    this.formGroup.controls["nameplateControl"].valueChanges.subscribe(
      (value) => {
        this.onChangeNameplate(value);
      }
    );
    this.formGroup.controls["selectAllReportFilters"].valueChanges.subscribe(
      (value) => {
        this.onChangeSelectAllFilters(value);
      }
    );
  }

  getMenuItems() {
    this.isLoading = true;
    this.vehicleVersionReportService.getVehicleVersionMenuItems().subscribe({
      next: (data: VehicleVersionMenuItem) => {
        this.vehicleIdList = data.vehicleIds;
        this.brandList = data.brands;
        this.oemList = data.oems;
        this.nameplateList = data.nameplates;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  getVehicleData(
    oems: String[],
    brands: String[],
    vehicleIds: number[],
    nameplates: String[]
  ) {
    this.isSubLoading = true;
    const filters = new VehicleVersionMenuItem(
      oems,
      brands,
      vehicleIds,
      nameplates
    );
    this.vehicleVersionReportService
      .getVehicleVersionReportData(filters, this.pageSize, this.pageNum)
      .subscribe({
        next: (data: VehicleDTO[]) => {
          this.vehicles = data;
        },
        error: (err: any) => {
          //do something with api error
        },
        complete: () => {
          this.isLoading = false;
          this.isSubLoading = false;
        },
      });
  }

  getNumberOfRecords(
    oems: String[],
    brands: String[],
    vehicleIds: number[],
    nameplates: String[]
  ) {
    const filters = new VehicleVersionMenuItem(
      oems,
      brands,
      vehicleIds,
      nameplates
    );
    this.isSubLoading = true;
    this.vehicleVersionReportService
      .getNumberOfVehicleRecords(filters)
      .subscribe({
        next: (data: number) => {
          this.numberOfRecords = data;
        },
        complete: () => {
          this.isSubLoading = false;
        },
      });
  }

  onPageChange($event) {
    this.pageNum = $event.first;
    this.pageSize = $event.rows;
    this.getNumberOfRecords(
      this.selectedOems,
      this.selectedBrands,
      this.selectedVehicleIds,
      this.selectedNameplates
    );
    this.getVehicleData(
      this.selectedOems,
      this.selectedBrands,
      this.selectedVehicleIds,
      this.selectedNameplates
    );
  }

  colorizeCells() {
    setTimeout(() => {
      for (let r = this.rows.length - 1; r > 0; r--) {
        for (let c = 0; c < this.rows.get(r).nativeElement.cells.length; c++) {
          if (
            this.rows.get(r).nativeElement.cells[c].innerHTML !==
              this.rows.get(r - 1).nativeElement.cells[c].innerHTML &&
            c != 18 &&
            this.rows.get(r).nativeElement.cells[0].innerHTML ==
              this.rows.get(r - 1).nativeElement.cells[0].innerHTML
          ) {
            this._renderer2.setStyle(
              this.rows.get(r - 1).nativeElement.cells[c],
              "backgroundColor",
              "#FFFF00"
            );
          }
        }
      }
    }, 10);
  }

  onChangeVehicleId(value: number[]) {
    this.selectedVehicleIds = value;
    this.formGroup.controls["selectAllReportFilters"].setValue(false, {
      emitEvent: false,
      onlySelf: true,
    });
  }

  onChangeBrand(value: String[]) {
    this.selectedBrands = value;
    this.formGroup.controls["selectAllReportFilters"].setValue(false, {
      emitEvent: false,
      onlySelf: true,
    });
  }

  onChangeOem(value: String[]) {
    this.selectedOems = value;
    this.formGroup.controls["selectAllReportFilters"].setValue(false, {
      emitEvent: false,
      onlySelf: true,
    });
  }

  onChangeNameplate(value: String[]) {
    this.selectedNameplates = value;
    this.formGroup.controls["selectAllReportFilters"].setValue(false, {
      emitEvent: false,
      onlySelf: true,
    });
  }

  onChangeSelectAllFilters(value: any) {
    if (value) {
      this.selectedOems = this.oemList;
      this.formGroup.controls["oemControl"].setValue(this.selectedOems, {
        onlySelf: true,
        emitEvent: false,
      });
      this.selectedBrands = this.brandList;
      this.formGroup.controls["brandControl"].setValue(this.selectedBrands, {
        onlySelf: true,
        emitEvent: false,
      });
      this.selectedVehicleIds = this.vehicleIdList;
      this.formGroup.controls["vehicleControl"].setValue(
        this.selectedVehicleIds,
        { onlySelf: true, emitEvent: false }
      );
      this.selectedNameplates = this.nameplateList;
      this.formGroup.controls["nameplateControl"].setValue(
        this.selectedNameplates,
        { onlySelf: true, emitEvent: false }
      );
      this.formGroup.controls["selectAllReportFilters"].setValue(true, {
        onlySelf: true,
        emitEvent: false,
      });
      this.formGroup.markAllAsTouched();
    }
  }

  clearFilters(): void {
    this.selectedOems = [];
    this.formGroup.controls["oemControl"].setValue(this.selectedOems, {
      onlySelf: true,
      emitEvent: false,
    });
    this.selectedBrands = [];
    this.formGroup.controls["brandControl"].setValue(this.selectedBrands, {
      onlySelf: true,
      emitEvent: false,
    });
    this.selectedVehicleIds = [];
    this.formGroup.controls["vehicleControl"].setValue(
      this.selectedVehicleIds,
      { onlySelf: true, emitEvent: false }
    );
    this.selectedNameplates = [];
    this.formGroup.controls["nameplateControl"].setValue(
      this.selectedNameplates,
      { onlySelf: true, emitEvent: false }
    );
    this.formGroup.controls["selectAllReportFilters"].setValue(false, {
      onlySelf: true,
      emitEvent: false,
    });
    this.formGroup.markAsUntouched();
    this.formGroup.reset();
  }
  generateReport() {
    this.getNumberOfRecords(
      this.selectedOems,
      this.selectedBrands,
      this.selectedVehicleIds,
      this.selectedNameplates
    );
    this.getVehicleData(
      this.selectedOems,
      this.selectedBrands,
      this.selectedVehicleIds,
      this.selectedNameplates
    );
  }
}
